import patientQueue from "@/components/patient/Queue";
import patientList from "@/components/patient/List";
import patientEdit from "@/components/patient/Edit";
import patientPrint from "@/components/patient/Print";

export default {
  path: "/",
  component: patientQueue,
  meta: {
    permission: "patient_queue:read|patient_queue:manage"
  },
  children: [
    {
      path: "",
      name: "patient-queue-list",
      component: patientList,
      meta: {
        title: "Patient Queue List",
        permission: "patient_queue:read|patient_queue:manage"
      }
    },
    {
      path: "/filters=:filters",
      name: "patient-queue-list-with-filter",
      component: patientList,
      props: true,
      meta: {
        title: "Patient Queue List",
        permission: "patient_queue:read|patient_queue:manage"
      }
    },
    {
      path: "patient/:id",
      name: "patient-edit",
      component: patientEdit,
      props: true,
      meta: {
        title: "Patient",
        permission: "patient_queue:read|patient_queue:manage"
      }
    },
    {
      path: "patient/:id/print",
      name: "patient-print",
      component: patientPrint,
      props: true,
      meta: {
        title: "Patient Print",
        permission: "patient_queue:read|patient_queue:manage"
      }
    }
  ]
};
